// extracted by mini-css-extract-plugin
export default {"wrapper":"view-button-box_wrapper__QMjPz","btnInactive":"view-button-box_btnInactive__VKmvP","btnActive":"view-button-box_btnActive__KhjAl"};